import { Navigate, useRoutes, Outlet } from 'react-router-dom';
import { lazy, Suspense } from 'react';
// layouts
import { GuestGuard } from 'src/auth/guard';
import Layout from 'src/layouts/layout';
import { LoginPage, ForgotPasswordPage, ResetPasswordPage, AcceptInvitationPage, PocSignupPage } from './main';
import { dashboardRoutes } from './dashboard';
import NotFoundPage from 'src/pages/404';

const PublicProposalPage = lazy(() => import('src/pages/public-proposal'));
const ContractSignPage = lazy(() => import('src/pages/contract-sign'));
const ContractReviewPage = lazy(() => import('src/pages/contract-review'));
const BillingRespondPage = lazy(() => import('src/pages/billing-respond'));
const CrewAppPage = lazy(() => import('src/pages/crew-app'));
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        <GuestGuard>
          <Outlet />
        </GuestGuard>
      ),
      children: [{ element: (
        <Layout>
          <LoginPage />
        </Layout>
      ), index: true }],
    },
    // Auth routes
    {
      path: '/auth',
      element: (
        <GuestGuard>
          <Layout>
            <Outlet />
          </Layout>
        </GuestGuard>
      ),
      children: [
        { path: 'login', element: <LoginPage /> },
        { path: 'forgot-password', element: <ForgotPasswordPage /> },
        { path: 'reset-password/:token', element: <ResetPasswordPage /> },
        { path: 'accept-invitation/:token', element: <AcceptInvitationPage /> },
        { path: 'poc-signup', element: <PocSignupPage /> },
      ],
    },
    // Public proposal view (no auth)
    {
      path: '/proposal/:shareToken',
      element: (
        <Suspense fallback={<div />}>
          <PublicProposalPage />
        </Suspense>
      ),
    },
    // Public contract signing (no auth)
    {
      path: '/contract/sign/:signingToken',
      element: (
        <Suspense fallback={<div />}>
          <ContractSignPage />
        </Suspense>
      ),
    },
    // Public contract review (no auth, read-only)
    {
      path: '/contract/review/:signingToken',
      element: (
        <Suspense fallback={<div />}>
          <ContractReviewPage />
        </Suspense>
      ),
    },
    // Public proforma accept/reject (no auth) — matches the URL the
    // share-token API returns: https://crm.example.com/billing/respond/<token>
    {
      path: '/billing/respond/:token',
      element: (
        <Suspense fallback={<div />}>
          <BillingRespondPage />
        </Suspense>
      ),
    },
    // Crew PWA (Task 14.1) — no auth, no dashboard shell. The magic-link
    // token IS the credential; the page exchanges it for a session itself.
    {
      path: '/crew/:token',
      element: (
        <Suspense fallback={<div />}>
          <CrewAppPage />
        </Suspense>
      ),
    },
    {
      path: '/404',
      element: (
          <NotFoundPage />
      ),
    },
    // Dashboard routes
    ...dashboardRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
